import { render, staticRenderFns } from "./icon-youtube.vue?vue&type=template&id=dcbf02fe&scoped=true&"
import script from "./icon-youtube.vue?vue&type=script&lang=js&"
export * from "./icon-youtube.vue?vue&type=script&lang=js&"
import style0 from "./icon-youtube.vue?vue&type=style&index=0&id=dcbf02fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbf02fe",
  null
  
)

export default component.exports